// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260826/js/" + chunkId + "." + {"44":"c7d259ed","225":"be1c7439","481":"36ac6b45","486":"603e55e3","770":"037dea1e"}[chunkId] + ".0.627145344695437.chunk.js";
};